<script>
import { lineFormatted } from '../../utils/formatting.js';

export default {
  name: 'RacingOddsComparisonTableOddCell',
  props: {
    selectionId: {
      type: Number,
      required: true,
    },
    odds: {
      type: String,
      default: '',
    },
    bookmakerId: {
      type: String,
      required: true,
    },
    betType: {
      type: String,
      required: true,
    },
    highestOddsList: {
      type: Object,
      required: true,
    },
    line: {
      type: Number,
      default: null,
    },
    quickbetEnabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valueStatus: '',
    };
  },
  computed: {
    bestOdds() {
      return this.highestOddsList[this.selectionId] || 0;
    },
    lineFormatted() {
      return lineFormatted(this.line);
    },
  },
  watch: {
    odds: 'oddsValueChanged',
  },
  methods: {
    oddsValueChanged: function(oldVal, newVal) {
      const valDiff = parseFloat(newVal) - parseFloat(oldVal);
      if (valDiff > 0) {
        // value increased
        this.valueStatus = 'odds-value-increased';
      } else if (valDiff < 0) {
        // value decreased
        this.valueStatus = 'odds-value-decreased';
      }
    },
  },
};
</script>

<template>
  <div :class="[{ 'quickbet-disabled': !quickbetEnabled }, `octd-right__odds-value ${valueStatus}`]">
    <span :class="bookmakerId" class="octd-right__bet-sign">bet</span>
    <div
      v-if="line"
      :class="[{ 'best-odds': odds === bestOdds }, 'octd-right__odds-value-cell']"
      :value-status="valueStatus"
    >
      <div class="octd-right__odds-value-cell__odds">{{ odds }}</div>
      <div class="octd-right__odds-value-cell__line">{{ lineFormatted }}</div>
    </div>
    <div
      v-else
      :class="[{ 'best-odds': odds === bestOdds }, 'octd-right__odds-value-cell']"
      :value-status="valueStatus"
      v-html="odds"
    ></div>
  </div>
</template>
